import Modal from "./modal";
import Alert, { AlertCategoryEnum } from "./Alert";
import * as React from "react";

interface WizardModalContentProps {
    disabled: boolean;
    onNext?: () => void;
    nextText?: string;
    onBack?: () => void;
    backText?: string;
}

export const WizardModalContent: React.FunctionComponent<WizardModalContentProps> = ({ children, backText, disabled, nextText, onBack, onNext }: React.PropsWithChildren<WizardModalContentProps>) => {

    return (<>
        <div className="modal-body">
            {children}
        </div>
        <div className="modal-footer">
            {onNext ? <button
                disabled={disabled}
                className="btn btn-primary"
                onClick={onNext}
            >{nextText}</button> : null}
            {onBack ? <button
                className="btn btn-outline btn-primary"
                onClick={onBack}>{backText}</button> : null}
        </div>
    </>)
}

interface WizardModalProps {
    onClose: () => void;
    isVisible: boolean;
    header: string;
    error: string;
}

export const WizardModal: React.FunctionComponent<WizardModalProps> = ({ children, isVisible, onClose, header, error }: React.PropsWithChildren<WizardModalProps>): JSX.Element => {

    return (<Modal
        show={isVisible}
        closeModalHandler={onClose}
        header={header}>
        <Alert show={!!error} category={AlertCategoryEnum.Danger} >
            {error}
        </Alert>
        {children}
    </Modal>);
}
